export const useDocumentThemeFlag = () => {
  // TODO: Remove this feature flag from the codebase
  const isEnabled = true

  return {
    isLoading: false,
    data: {
      isEnabled,
    },
  }
}
